import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = () => (

  <svg width="51" height="20" viewBox="0 0 51 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.7045 9.62638V15.4624H21.8398V1.05078H26.7831C28.0359 1.05078 29.1042 1.46558 29.9782 2.29516C30.8717 3.12475 31.3184 4.13761 31.3184 5.33376C31.3184 6.55885 30.8717 7.57171 29.9782 8.39165C29.1139 9.21159 28.0456 9.61674 26.7831 9.61674H23.7045V9.62638ZM23.7045 2.82571V7.85145H26.8219C27.56 7.85145 28.1815 7.60065 28.6671 7.10869C29.1624 6.61672 29.4149 6.01865 29.4149 5.3434C29.4149 4.67781 29.1624 4.08938 28.6671 3.59742C28.1815 3.08616 27.5697 2.83535 26.8219 2.83535H23.7045V2.82571Z"
      fill="#333333"
    />
    <path
      d="M36.1947 5.27734C37.5737 5.27734 38.6614 5.6439 39.4578 6.37703C40.2542 7.11015 40.6523 8.11337 40.6523 9.38669V15.4639H38.8751V14.0941H38.7974C38.0302 15.2227 37.0008 15.7822 35.7188 15.7822C34.6214 15.7822 33.7085 15.4639 32.9704 14.8176C32.2323 14.1713 31.8633 13.3706 31.8633 12.406C31.8633 11.3835 32.2517 10.5732 33.0287 9.97511C33.8056 9.36739 34.8448 9.06836 36.1364 9.06836C37.2435 9.06836 38.1564 9.27093 38.8654 9.67608V9.25164C38.8654 8.60533 38.6129 8.06514 38.0982 7.61176C37.5835 7.15838 36.9813 6.93651 36.2918 6.93651C35.2527 6.93651 34.4272 7.3706 33.825 8.24842L32.1838 7.2259C33.0869 5.92365 34.4272 5.27734 36.1947 5.27734ZM33.7862 12.4349C33.7862 12.9172 33.9901 13.3224 34.4077 13.6407C34.8156 13.9591 35.3012 14.123 35.8548 14.123C36.6414 14.123 37.3407 13.8337 37.9525 13.2549C38.5643 12.6761 38.8751 12.0008 38.8751 11.2195C38.2924 10.7661 37.4863 10.5346 36.4472 10.5346C35.6897 10.5346 35.0584 10.7179 34.5534 11.0748C34.0387 11.451 33.7862 11.9044 33.7862 12.4349Z"
      fill="#333333"
    />
    <path
      d="M50.7925 5.59375L44.577 19.7932H42.6541L44.9655 14.8253L40.8672 5.59375H42.8969L45.8493 12.6742H45.8881L48.7628 5.59375H50.7925Z"
      fill="#333333"
    />
    <path
      d="M16.2916 8.44825C16.2916 7.84438 16.2372 7.26657 16.1362 6.71094H8.32031V9.89423L12.8217 9.8952C12.6391 10.9544 12.0515 11.8573 11.1513 12.4592V14.5245H13.8307C15.3952 13.0862 16.2916 10.9602 16.2916 8.44825Z"
      fill="#4285F4"
    />
    <path
      d="M11.148 12.4627C10.4022 12.9624 9.44169 13.2547 8.31805 13.2547C6.1475 13.2547 4.30617 11.802 3.64675 9.84375H0.882812V11.9737C2.25215 14.6727 5.06659 16.5248 8.31805 16.5248C10.5653 16.5248 12.4533 15.7907 13.8275 14.5271L11.148 12.4627Z"
      fill="#34A853"
    />
    <path
      d="M3.38839 8.26173C3.38839 7.71189 3.48065 7.18038 3.64866 6.6807V4.55078H0.88473C0.318541 5.66686 0 6.92668 0 8.26173C0 9.59678 0.319512 10.8566 0.88473 11.9727L3.64866 9.84277C3.48065 9.34309 3.38839 8.81157 3.38839 8.26173Z"
      fill="#FABB05"
    />
    <path
      d="M8.31805 3.27011C9.54463 3.27011 10.643 3.68973 11.5103 4.50967L13.8848 2.15306C12.4426 0.818975 10.5624 0 8.31805 0C5.06756 0 2.25215 1.8521 0.882812 4.55114L3.64675 6.68106C4.30617 4.72285 6.1475 3.27011 8.31805 3.27011Z"
      fill="#E94235"
    />
  </svg>
);

export default Icon;
